import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  ProjectPropertiesMenuItem,
  ProjectPropertiesMenuItemPrefix,
  ProjectPropertiesMenuItemValue,
} from '@/features/projects/project-details/components/layouts/project-properties-menu-layout';
import { useUpdateProjectStatus } from '@/features/projects/project-details/hooks/use-update-project-status';
import { ProjectStatusIndicator } from '@/features/projects/projects-hub/components/project-status-indicator';
import {
  getProjectStatusDisplay,
  ProjectStatus,
  projectStatusOptions,
} from '@/features/projects/shared/types/project-status';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/shared/components/ui/select';

export const StatusItem = ({
  projectId,
  projectStatus,
}: {
  projectId: number;
  projectStatus: ProjectStatus | null;
}) => {
  const { t } = useTranslation('project', { keyPrefix: 'Shared' });
  const { t: tShared } = useTranslation('shared');

  const mutation = useUpdateProjectStatus();

  const handleStatusChange = (newStatus: ProjectStatus) => {
    mutation.mutate({
      projectId,
      status: newStatus,
    });
  };

  const [isOpen, setIsOpen] = useState(false);

  return (
    <ProjectPropertiesMenuItem isEditable onEdit={() => setIsOpen(true)}>
      <ProjectPropertiesMenuItemPrefix>
        {t('status')}
      </ProjectPropertiesMenuItemPrefix>
      <ProjectPropertiesMenuItemValue>
        <div className="cursor-pointer" onClick={() => setIsOpen(true)}>
          <ProjectStatusIndicator
            status={projectStatus ?? ProjectStatus.ACTIVE}
          />
        </div>
        <Select
          defaultValue={projectStatus ?? undefined}
          onValueChange={handleStatusChange}
          open={isOpen}
          onOpenChange={setIsOpen}
        >
          <SelectTrigger isInputTrigger={true} className="sr-only" size={'sm'}>
            <SelectValue placeholder={t('status')} asLabelInput={false}>
              {getProjectStatusDisplay({
                status: projectStatus,
                t: tShared,
              })}
            </SelectValue>
          </SelectTrigger>
          <SelectContent className="text-white">
            {projectStatusOptions.map((status) => (
              <SelectItem className="text-white" key={status} value={status}>
                {getProjectStatusDisplay({
                  status,
                  t: tShared,
                })}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </ProjectPropertiesMenuItemValue>
    </ProjectPropertiesMenuItem>
  );
};
